export default "__VITE_ASSET__Cj7bC940__"